// import { Operation } from 'slate';
import { createTPluginFactory, ElementPluginOptions } from '../../plate';
import { KEY_AI } from '../../pluginKeys';

// const withApplyInterceptor = (
//   editor,
// ) => {
//   const { apply } = editor;

//   // eslint-disable-next-line no-param-reassign
//   editor.apply = (op: Operation) => {
//     console.log(editor.selection, op);
//     apply(op);
//     console.log(editor.children?.[0]?.children);
//   };

//   return editor;
// };

export const createAiPlugin = createTPluginFactory<ElementPluginOptions>({
  key: KEY_AI,
  isElement: true,
  // withOverrides: withApplyInterceptor,
  options: {
    isDreamBlock: true,
    meta: {
      img: '/canvas/images/accordion.png',
      title: 'Dream',
      subtitle:
        'Create your dream site contents in an instant',
      keywords: ['ai', 'dream'],
    },
    format: {
      formatType: 'command',
      // we just insert a paragraph, but open the dream modal
      onInsert: () => {
        throw Error('Did you forget to implement onInsert for the AI plugin?');
      },
      validProperties: [],
      focusableWhenEmpty: true,
    },
  },
});
